import React from 'react';
import { useTranslation } from 'react-i18next';
import divingImage from '../assets/Diving/135-1024x679-1.jpg';
import coralReefImage from '../assets/Diving/db.jpg';
import shipwreckImage from '../assets/Diving/Diving_Weligama.jpg';

const DivingPage = () => {
    const { t } = useTranslation();

    return (
        <div className="py-16 px-4 sm:px-8 lg:px-16 bg-gradient-to-b from-[#FFFFFF] to-[#F8F1E9] min-h-screen font-customFont">
            {/* Title */}
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-center text-[#122C56] mb-12 tracking-tight drop-shadow-md animate-fade-in">
                {t('divingPage.title')}
            </h1>

            {/* Main Section */}
            <div className="max-w-7xl mx-auto mt-8 flex flex-col lg:flex-row gap-8 items-center">
                {/* Left Section: Image */}
                <div className="w-full lg:w-1/3">
                    <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                        <img
                            src={divingImage}
                            alt={t('divingPage.images.mainAlt')}
                            className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                    </div>
                </div>

                {/* Right Section: Text Content */}
                <div className="flex-1 bg-white p-8 rounded-2xl shadow-xl">
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed mb-6">
                        {t('divingPage.mainDescription')}
                    </p>
                    <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                        {t('divingPage.northeastDescription')}
                    </p>
                </div>
            </div>

            {/* Facilities Section */}
            <div className="max-w-7xl mx-auto mt-12 bg-white p-8 rounded-2xl shadow-xl">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#122C56] mb-6 drop-shadow-md">
                    {t('divingPage.facilitiesTitle')}
                </h2>
                <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed mb-6">
                    {t('divingPage.facilitiesDescription')}
                </p>
                <p className="text-gray-700 text-base sm:text-lg md:text-xl leading-relaxed">
                    {t('divingPage.popularSpots')}
                </p>
            </div>

            {/* Images Section */}
            <div className="max-w-7xl mx-auto mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Additional Image 1 */}
                <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                    <img
                        src={coralReefImage}
                        alt={t('divingPage.images.coralReefAlt')}
                        className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                    <div className="absolute bottom-0 left-0 right-0 bg-[#F8F1E9] bg-opacity-90 p-4">
                        <p className="text-[#122C56] text-sm sm:text-base font-semibold text-center">
                            {t('divingPage.images.coralReefCaption')}
                        </p>
                    </div>
                </div>

                {/* Additional Image 2 */}
                <div className="relative overflow-hidden rounded-2xl shadow-xl group">
                    <img
                        src={shipwreckImage}
                        alt={t('divingPage.images.shipwreckAlt')}
                        className="w-full h-64 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#122C56] to-transparent opacity-0 group-hover:opacity-70 transition-opacity duration-300"></div>
                    <div className="absolute bottom-0 left-0 right-0 bg-[#F8F1E9] bg-opacity-90 p-4">
                        <p className="text-[#122C56] text-sm sm:text-base font-semibold text-center">
                            {t('divingPage.images.shipwreckCaption')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Tips Section */}
            <div className="max-w-7xl mx-auto mt-12 bg-white p-8 rounded-2xl shadow-xl">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#122C56] mb-6 drop-shadow-md">
                    {t('divingPage.tipsTitle')}
                </h2>
                <ul className="list-none space-y-4 text-gray-700 text-base sm:text-lg leading-relaxed">
                    {[
                        t('divingPage.tips.season'),
                        t('divingPage.tips.certifiedCenter'),
                        t('divingPage.tips.instructorAdvice'),
                        t('divingPage.tips.respectMarineLife'),
                        t('divingPage.tips.camera'),
                    ].map((tip, index) => (
                        <li key={index} className="flex items-center">
                            <span className="w-2 h-2 bg-[#C58E2F] rounded-full mr-2"></span>
                            {tip}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default DivingPage;